import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapperVW'
import HeadTitle from 'src/components/atoms/HeadTitle'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { vwSize } from 'src/utils/vwCss'
import { Image } from 'src/components/atoms/Image'
// image
import BGFeatures from 'src/images/top/features/bg.jpg'

const points = [
  {
    imageName: 'group',
    title: 'グループ管理',
    description:
      'ユーザー属性に応じたコンテンツの出し分けが可能です。ユーザー体験を最も細やかなレベルで最適化することができます。'
  },
  {
    imageName: 'badge',
    title: 'ポイント・バッジ',
    description:
      'ユーザーの能動的なアクションを促す、ポイント機能・バッジ機能を搭載。特定のアクションに対するインセンティブ付与が簡単にできます。'
  },
  {
    imageName: 'knowledge_base',
    title: 'ナレッジベース・トレーニング',
    description:
      'ストック型コンテンツの蓄積やトレーニングに特化したUIを提供し、ユーザーの自己解決を促進。運営効率化をサポートします。'
  },
  {
    imageName: 'event',
    title: 'イベント',
    description:
      'オンライン・オフライン双方のイベント管理が簡単に。ユーザーの参加申込やユーザー管理がその場で可能になります。'
  },
  {
    imageName: 'q_and_a',
    title: 'Q&A',
    description:
      '質問・解答がしあえるQ&A機能を設置。ユーザーフォーラムや知恵袋のような機能が簡単に実装できます。'
  },
  {
    imageName: 'app',
    title: 'アプリ',
    description:
      'リテンションに効果的なコミュニティアプリを提供。プッシュ通知でユーザーに情報を直接届けます。自社オリジナルアプリも作成可能。'
  },
  {
    imageName: 'analysis',
    title: '分析',
    description:
      '純正の分析画面をご提供。タグの埋め込みは必要ありません。CSV export・API接続も可能で、BIツール等での詳細分析にも対応しています。'
  },
  {
    imageName: 'monitoring',
    title: '24時間365日モニタリング',
    description:
      '投稿やコメントをモニタリングし、活性化と炎上リスク抑制の両立を実現。ISMS認証も取得しており、安心して運用していただけます。'
  },
  {
    imageName: 'api',
    title: 'commmune API / SSO',
    description:
      'CRM/SFA/MAツールや自社サービスなど、APIを提供する外部サービスと連携可能。ご利用中のログインシステムも利用でき、IDに紐付く分析も容易になります。'
  }
]

export const TopFeatures = () => {
  const data = useStaticQuery(graphql`
    query {
      group: file(relativePath: { eq: "top/features/group.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      badge: file(relativePath: { eq: "top/features/badge.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      knowledge_base: file(
        relativePath: { eq: "top/features/knowledge_base.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      event: file(relativePath: { eq: "top/features/event.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      q_and_a: file(relativePath: { eq: "top/features/q_and_a.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      app: file(relativePath: { eq: "top/features/app.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      analysis: file(relativePath: { eq: "top/features/analysis.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      monitoring: file(relativePath: { eq: "top/features/monitoring.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      api: file(relativePath: { eq: "top/features/api.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <FadeDownWrap>
          <HeadingBorder heading="FEATURES" />
        </FadeDownWrap>
        <FadeDownWrap>
          <HeadTitle as="h2" className={"g-h2"}>commmuneの提供機能</HeadTitle>
        </FadeDownWrap>
        <PointCardLayoutWrapper>
          <PointCardLayoutEx>
            {points.map(point => {
              const { childImageSharp } = data[point.imageName]
              const imageFluid = childImageSharp && childImageSharp.fluid
              return (
                <FadeDownWrap>
                  <PointCard>
                    {imageFluid ? (
                      <RasterImageWrapper>
                        <RasterImage imageFluid={imageFluid} />
                      </RasterImageWrapper>
                    ) : (
                      <VectorImage src={imageUrl} alt="" />
                    )}
                    <PointTtl>
                      {point.title}
                    </PointTtl>
                    <PointDescription>
                      {point.description}
                    </PointDescription>
                  </PointCard>
                </FadeDownWrap>
              )
            })}
          </PointCardLayoutEx>
        </PointCardLayoutWrapper>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  background-image: url(${BGFeatures});
  background-repeat; no-repeat;
  background-position; center bottom;
  background-size: cover;
  width: 100%;

`
const PointCardLayoutWrapper = styled.div`
  margin: ${vwSize(64, 'pc')}vw 0 0;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin: ${vwSize(48, 'sp')}vw 0 0;
  }
`
const PointCardLayoutEx = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > div {
    width: ${vwSize(330, 'pc')}vw;
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      width: ${vwSize(158, 'sp')}vw;
    }
  }
`
const PointCard = styled.div`
  margin-bottom: ${vwSize(64, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-bottom: ${vwSize(48, 'sp')}vw;
  }
`
const PointTtl = styled.div`
  font-size: ${vwSize(20, 'pc')}vw;
  font-weight: ${Styles.fontWeight.bold};
  text-align: center;
  margin: ${vwSize(24, 'pc')}vw 0;
  color: ${Styles.color.primary[400]};
  letter-spacing: ${Styles.pc.letterSpacing};
  line-height: ${Styles.lineHeight[350]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.h3};
    margin: ${vwSize(12, 'sp')}vw 0;
    text-align: left;
  }
`
const PointDescription = styled.div`
  font-size: ${Styles.pc.fontSize.text};
  color: ${Styles.pc.color.text};
  line-height: ${Styles.lineHeight[500]};
  letter-spacing: ${Styles.pc.letterSpacing};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(14, 'sp')}vw;
  }
`
const RasterImageWrapper = styled.div`
  border-radius: ${vwSize(8, 'pc')}vw;
  overflow: hidden;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    border-radius: ${vwSize(8, 'sp')}vw;
  }
`
const RasterImage = styled(Image)`
  filter: drop-shadow(8px 8px 20px rgba(112, 181, 197, 0.15));
`

const VectorImage = styled.img`
`
